import { Spin } from 'antd';
import { AreaChart } from '@components/charts';
import { useWidgetData } from '@hooks/useWidgetData';
import type { WidgetDefinition, WidgetRenderProps } from '@/types';

interface Config {
  color?: string;
  stacked?: boolean;
  dataSet?: string;
  xColumn?: string;
  yColumn?: string;
  showGrid?: boolean;
  xAxisLabel?: string;
  yAxisLabel?: string;
  yAxisMin?: number | null;
  yAxisMax?: number | null;
}
interface Data {
  categories: string[];
  series: Array<{ name: string; data: number[] }>;
}

function AreaWidget({ instance }: WidgetRenderProps<Config>) {
  const { data, isLoading } = useWidgetData<Data>(
    instance.id,
    'area',
    instance.config as Record<string, unknown>,
    instance.refreshInterval,
  );
  if (isLoading) return <Spin />;
  return (
    <AreaChart
      categories={data?.categories ?? []}
      series={data?.series ?? []}
      stacked={instance.config.stacked}
      color={instance.config.color}
      showGrid={instance.config.showGrid}
      xAxisLabel={instance.config.xAxisLabel}
      yAxisLabel={instance.config.yAxisLabel}
    />
  );
}

export const areaWidgetDef: WidgetDefinition<Config> = {
  type: 'area',
  name: 'Area Chart',
  description: 'Filled trend line',
  icon: 'AreaChartOutlined',
  category: 'chart',
  defaultTitle: 'Area Chart',
  defaultConfig: { showGrid: true },
  minW: 4,
  minH: 4,
  defaultW: 6,
  defaultH: 6,
  component: AreaWidget,
  settingsSchema: {
    fields: [
      { key: 'stacked', label: 'Stacked', type: 'boolean' },
    ],
  },
};
